


























import { Component, Vue, Prop } from "vue-property-decorator";
import { TwilioTaskModel } from "@/models/TwilioTaskModel";
import PropertyList from "@/components/PropertyList.vue";
import { Property } from "@/models/Property";

@Component({
  components: {
    PropertyList,
  },
})
export default class PropertyView extends Vue {
  @Prop({ default: () => new TwilioTaskModel() })
  private task!: TwilioTaskModel;
  private taskJSON: any = "";

  private showingJSON = false;
  public get showView(): string {
    return this.showingJSON ? "Show Task" : "Show JSON";
  }
  public get showIcon(): string {
    return this.showingJSON ? "tasks" : "code";
  }

  private taskProperties: Property[] = [
    { displayName: "Task SID", propertyName: "sid" },
    { displayName: "Conference SID", propertyName: "ConferenceId", isInAttributes: true },
    { displayName: "From Worker Name", propertyName: "assignedWorkerName" },
    { displayName: "Priority", propertyName: "priority" },
    { displayName: "Call SID", propertyName: "call_sid", isInAttributes: true },
    { displayName: "Zing Task Type", propertyName: "ZingTaskType", isInAttributes: true },
    { displayName: "Age", propertyName: "timeSinceCreated", isATime: true },
    { displayName: "From", propertyName: "from", isInAttributes: true },
    { displayName: "To", propertyName: "to", isInAttributes: true },
  ];

  private mounted() {
    this.taskJSON = JSON.stringify(this.task, null, 2);
  }

  private showJSON() {
    this.showingJSON = !this.showingJSON;
  }
}
